import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import TestimonialTemplate from './TestimonialTemplate';

const Testimonials = () => {
    const reviews = [
        {
            testimonial: "The CharmHealth-Fullscript integration has greatly improved our clinic’s care by making it easier for patients to access professional-grade supplements, resulting in improved patient satisfaction and better clinical outcomes.",
            headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/andre_wong.png",
            name: "Andrew Wong, MD, FACP, IFMCP",
            title: "CEO & Medical Director, Capital Integrative Health"
        },
        {
            testimonial: "With respect to integrated payments with Bluefin and CharmHealth, there's a huge value in having everything in one location. It is just a very intuitive software really speeds up efficiency makes things that much better.",
            headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/Sleiman.png",
            name: "Joseph E. Sleiman, MD, FAAFP",
            title: "Founder & CEO, Clinic45"
        },
        {
            testimonial: "It really makes filling prescriptions, refilling prescriptions, much, much easier. From a couple of clicks of the button, when I’m in the patient encounter, I can pull up a medication, whether it’s controlled or not, and send it on its way to the pharmacy, because at this point, all pharmacies participate in e-prescription. So that is a huge part of the workflow.",
            headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/dude.png",
            name: "Dr. Reza Hosseini Ghomi, MD, MSE",
            title: "CTO & Co-Founder of Frontier Psychiatry"
        },
    ]

    const [currentIndex, setCurrentIndex] = useState(0);
    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length);
    };

    return (
        <div className="w-full h-fit bg-[#f0f0f0] flex flex-col pb-[48px] relative">
            <div className="3xl:mt-20 mx-auto my-[48px] min-h-[64px] min-w-[64px] bg-cover bg-center" style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/quote.png)` }}></div>

            <button onClick={prevSlide} className="absolute left-[40px] 1.5xl:left-[120px] 3xl:left-[160px] top-1/2 transform -translate-y-1/2">
                <svg className="mr-1" width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill="#9a016a" />
                </svg>
            </button>

            <div className="">
                <Carousel
                    showArrows={false}
                    infiniteLoop={true}
                    showThumbs={false}
                    showStatus={false}
                    showIndicators={false}
                    selectedItem={currentIndex}
                    onChange={(index) => setCurrentIndex(index)}
                >
                    {reviews.map((review, index) => (
                        <div key={index} className="flex flex-col items-center">
                            <TestimonialTemplate
                                testimonial={review.testimonial}
                                headshot={review.headshot}
                                name={review.name}
                                title={review.title}
                            />
                        </div>
                    ))}
                </Carousel>
            </div>

            <button onClick={nextSlide} className="absolute right-[40px] 1.5xl:right-[120px] 3xl:right-[160px] top-1/2 transform -translate-y-1/2 z-10">
                <svg className="mr-1" width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9953 8.59269C11.9953 8.81799 11.8915 9.04322 11.6693 9.22105L2.77709 16.3349C2.34732 16.6787 1.63592 16.6787 1.20612 16.3349C0.776345 15.9911 0.776345 15.422 1.20612 15.0781L9.31282 8.59277L1.20612 2.10742C0.776345 1.7636 0.776345 1.19448 1.20612 0.85064C1.6359 0.506818 2.3473 0.506818 2.77709 0.85064L11.6693 7.9645C11.8915 8.14233 11.9953 8.36762 11.9953 8.59285V8.59269Z" fill="#9a016a" />
                </svg>
            </button>
        </div >
    );
}

export default Testimonials;